/**
 * Created by fers on 29.07.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {Navbar, Nav, NavItem} from 'react-bootstrap';
import * as Tool from '../fw/Tool';
import types from '../../common/model-api/types';
import {injectIntl, FormattedMessage, defineMessages} from 'react-intl';
import Relay from 'react-relay';
import ScenarioBox from '../scenarios/ScenarioBox.react';
import urlMapping from '../app/URLMapping';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import AppPanel from '../fw/AppPanel.react';
import Link from 'react-router/lib/Link';
import config from '../../common/config';
import ChannelHeader from '../channels/ChannelHeader.react';
// import GridList from '../fw/GridList.react';
import {scrollTo} from '../commonFunctions';
import ApplicationsBox from '../web/applicationsBox.react';
import {onInit, ApplicationObserver, getSelectedFragnents, getSelectedFromUrl} from '../web/SelectWidget.react';
import {LoadingLine} from '../loadingLine/renderLoadingPanel.react';
import NoScenariosMail from '../web/noScenariosMail.react';
import * as BrowserPermission from '../BrowserPermission';
import * as Permission from '../../common/util/Permission';
import AgentLink from '../fw/AgentLink.react';

import './channelDefDetail.scss';

const messages = defineMessages({
	title: {id: 'ChannelDefDetail.pageTitle', 'defaultMessage': '{appName} - integration with web applications with {productName}'},
	excerpt: {id: 'ChannelDefDetail.excerpt', 'defaultMessage': '{appName} is supported as Dativery integration. {description} / {longDescription}'},
});

const sortScenarios = (scenarios) => {
    return scenarios.sort((a, b) => {
        const nameA = (a.node && a.node.title) ? a.node.title : '';
        const nameB = (b.node && b.node.title) ? b.node.title : '';
        return nameA.localeCompare(nameB);
    });
};

class ChannelDefDetail extends React.Component {
	static propTypes = {
		intl: PropTypes.object,
		relay: PropTypes.object,
		user: PropTypes.object.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			loading: false
		};
	}

	componentDidMount() {
		onInit();

		this.applicationObserver = (applications) => {
			this.onApplicationChange(applications);
		};
		ApplicationObserver.subscribe(this.applicationObserver);
	}

	componentWillUnmount() {
		ApplicationObserver.unsubscribe(this.applicationObserver);
	}

	onApplicationChange(applications) {
		LoadingLine.start();
		this.setState({
			loading: true
		});

		this.props.relay.setVariables({
			channelDefUrlFragments: applications.map(app => app.urlFragment)
		});
	}

	getChannelDef() {
		return this.props.user.channelDefs.edges[0].node;
	}

	getRequiredPayPlan() {
		let channelDef = this.getChannelDef();
		let metadata = types['channelDefs'];

		let requiredPayPlan = channelDef.requiredPayPlan;
		let addonRequiredPayPlan = channelDef.addonRequiredPayPlan;

		if (requiredPayPlan) {
			if (addonRequiredPayPlan && addonRequiredPayPlan !== requiredPayPlan) {
				if (addonRequiredPayPlan === "-") {
					addonRequiredPayPlan = (<FormattedMessage defaultMessage="Addon can be used in all plans."
												id="channelDef.addonPayPlan.inAll" />);
				} else {
					addonRequiredPayPlan = (<FormattedMessage defaultMessage="Addon can be used in {planName} or higher."
												id="channelDef.addonPayPlan.requires"
												values={{planName: Tool.getFormatted(metadata, 'addonRequiredPayPlan', this.props.intl.formatMessage, channelDef)}}/>);
				}
			}

			if (requiredPayPlan === "-") {
				requiredPayPlan = null;
			} else {
				requiredPayPlan = Tool.getFormatted(metadata, 'requiredPayPlan', this.props.intl.formatMessage, channelDef);
			}
		}

		if (addonRequiredPayPlan === "-") {
			addonRequiredPayPlan = null;
		}

		// return {
		// 	requiredPayPlan: requiredPayPlan,
		// 	addonRequiredPayPlan: addonRequiredPayPlan
		// };

		return (requiredPayPlan || channelDef.extraPayment || addonRequiredPayPlan) ?
			(<span className="payment-info">
			{requiredPayPlan || channelDef.extraPayment ?
				requiredPayPlan ?
					(channelDef.extraPayment ?
							<FormattedMessage
								defaultMessage="Requires {planName} and extra payment for some service."
								id="channelDef.payPlan.requires-and-payment"
								values={{planName: requiredPayPlan}}/>
							:
							<FormattedMessage defaultMessage="Requires {planName} or higher." id="channelDef.payPlan.requiresOrHigher" values={{planName: requiredPayPlan}}/>
					) :
					<FormattedMessage defaultMessage="Requires extra payment for some service." id="channelDef.payPlan.requires-extra-payment" />
				: null
			}{" "}{addonRequiredPayPlan ?
				addonRequiredPayPlan
				: null
			}
			<br/></span>)
		: null;
	}

	getTagsTag() {
		let tagsTag = null;
		let channelDef = this.getChannelDef();
		let metadata = types['channelDefs'];
		let columnMapping = Tool.getMappingForColumn('state', metadata.fields());

		let tags = Tool.getDataForColumn('state', metadata.fields(), channelDef);
		if (tags) {
			if (!('hide' in columnMapping['values'][tags]) && !columnMapping['values'][tags].hide) {
				let style = {};
				if (columnMapping['values'][tags].color) {
					style['backgroundColor'] = columnMapping['values'][tags].color;
				}
				tagsTag = (
					<span className="badge" style={style}>{Tool.tranformDataForView(metadata.entity(), columnMapping, this.props.intl.formatMessage, tags, true)}</span>);
			}
		}

		return tagsTag;
	}

	getAppDescription(longDescription) {
		let channelDef = this.getChannelDef();
		let metadata = types['channelDefs'];

		if (longDescription) {
			longDescription = Tool.tranformDataForView('channelDefs', metadata.fields('longDescription'), this.props.intl.formatMessage, longDescription, false, 0);
		} else {
			longDescription = channelDef.description;
		}

		return longDescription;
	}

	getConnectRequirement() {
		let channelDef = this.getChannelDef();
		let metadata = types['channelDefs'];
		let connectRequirement = null;

		if (channelDef.connectRequirement) {
			connectRequirement = Tool.getFormatted(metadata, 'connectRequirement', this.props.intl.formatMessage, channelDef);
		}
        if (channelDef.requiresAgent) {
            connectRequirement = (<span><FormattedMessage defaultMessage="Requires installation of {agentLink}." id="channelDef.requiresAgentUrl" values={{
                productName: config.PRODUCT_NAME,
                agentLink: <AgentLink />
            }} /> {connectRequirement}</span>);
        }
		return connectRequirement;
	}

	render() {
		let channelDef = this.getChannelDef();
		let metadata = types['channelDefs'];
		let allSortedScenarios = sortScenarios(channelDef.allScenarios.edges);
		let countScenarios = channelDef.allScenarios.edges.length;
		let {
			name,
			description,
			longDescription
		} = Tool.getDataForColumns(['name', 'description', 'longDescription'], metadata.fields(), channelDef);
		let pageTitle = this.props.intl.formatMessage(messages.title, {appName: name, productName: config.PRODUCT_NAME});
		let connectRequirement = this.getConnectRequirement();
		let createUrl = urlMapping.getUrl(types['channels'], 'create-pre', {id: channelDef.realId, 'urlFragment': channelDef.urlFragment}) + (typeof window === 'object' && 'document' in window && window.document.location.search ? window.document.location.search : "");
		longDescription = this.getAppDescription(longDescription);

		return (
			<AppPanel breadcrumbParams={[
				{type: metadata, data: channelDef},
			]} className="channelDefDetail" id="home" title={pageTitle}>
				<div data-aliases={channelDef.aliases}
					data-description={description}
					data-excerpt={this.props.intl.formatMessage(messages.excerpt, {appName: name, description: description, longDescription: longDescription})}
					data-keywords={channelDef.keywords}
					data-tags={channelDef.tags}
					data-title={pageTitle}
					data-typos={channelDef.typos}
				>
					<ChannelHeader data={channelDef} isChannelDef tag={this.getTagsTag()} title={name}>
						{channelDef.publicWeb ? <span><a href={channelDef.publicWeb}>{channelDef.publicWeb.replace("https://", "").replace("http://", "").replace(/\/$/, "")}</a></span> : null}
					</ChannelHeader>

					<p className="aplicationDescription">{longDescription}</p>

					<p className="notes">
						<span className="privacy"><strong>{Tool.getLabel(metadata, 'privacy', this.props.intl.formatMessage)}:</strong> {Tool.getFormatted(metadata, 'privacy', this.props.intl.formatMessage, channelDef)}<br/></span>
						{connectRequirement ? <span className="connect-requirement"><strong>{Tool.getLabel(metadata, 'connectRequirement', this.props.intl.formatMessage)}:</strong> {connectRequirement}<br/></span> : null}
						{/* this.getRequiredPayPlan() */}
					</p>

					{channelDef.addType !== 'none' && !channelDef.hideAddButton ?
						<div className="btn-toolbar">
							<div className="btn-group">
								<div className="dativery-create-channel-button">
                                    {channelDef.showContactUs && !BrowserPermission.hasPermission(Permission.PERM_EDIT_CHANNEL_DEF) ?
                                        <Link className="btn btn-primary" href={"mailto:" + config.SALES_EMAIL + '?subject=' + encodeURIComponent(name)}><span className="fa fa-envelope"/>{" "}
											<FormattedMessage defaultMessage="Contact Us" id="channelDef.contactUs" />
                                        </Link>
                                        :
                                        <Link className="btn btn-primary" href={config.PUBLIC_APP_URL + createUrl} to={createUrl}><span className="fa fa-plus"/>{" "}
											<FormattedMessage defaultMessage="Connect" id="channelDef.connect" />
                                        </Link>
                                    }
								</div>
							</div>
						</div>
					: null}

					{channelDef.integratedApps.edges.length > 0 ?
						<div>
							<h3 className="scrollTarget" id="applications"><FormattedMessage defaultMessage="Choose with what application should {application} be integrated:" id="channel.connectedApplications2" values={{application: name}} /></h3>
							<ApplicationsBox applications={this.getChannelDef().integratedApps.edges} />
						</div>
					: null}

					<LoadingLine />

					{allSortedScenarios.length > 0 ?
                        <div>
                            <div className="channelDefDetail-header">
                                <h3 className="scrollTarget" id="allScenarios">
                                    <FormattedMessage
                                        defaultMessage="All scenarios related to {application}:"
                                        id="channel.allScenariosHeader"
                                        values={{application: name}}
                                    />
                                </h3>
                                <div className={"resultsCount flex-none" + (countScenarios !== 0 ? '' : ' hidden')}>
                                    <FormattedMessage
                                        defaultMessage="{countScenarios, number} {countScenarios, plural, one {scenario} other {scenarios}} found"
                                        id="channel.countScenarios"
                                        values={{countScenarios: countScenarios}}
                                    />
                                </div>
                            </div>
							<div className="scenarioGridList">
                                {allSortedScenarios.map(({node}, idx) => (
                                    node ? <ScenarioBox
                                        key={idx}
                                        metadata={types['scenarios']}
                                        scenario={node}
                                        urlMapping={urlMapping}
                                    /> : null
                                ))}
                            </div>
                        </div>
                    : null }

					{allSortedScenarios.length === 0 ? <NoScenariosMail selectedApplications={[this.getChannelDef(), ...getSelectedFromUrl()]} /> : null}

					<div className="channelDef-bottom">
						{channelDef.keywords ? <span className="">{Tool.getLabel(metadata, 'keywords', this.props.intl.formatMessage)}: {Tool.getFormatted(metadata, 'keywords', this.props.intl.formatMessage, channelDef)}<br/></span> : null}
						{channelDef.aliases ? <span className="">{Tool.getLabel(metadata, 'aliases', this.props.intl.formatMessage)}: {Tool.getFormatted(metadata, 'aliases', this.props.intl.formatMessage, channelDef)}<br/></span> : null}
						{channelDef.typos ? <span className="">{Tool.getLabel(metadata, 'typos', this.props.intl.formatMessage)}: {Tool.getFormatted(metadata, 'typos', this.props.intl.formatMessage, channelDef)}<br/></span> : null}
						{channelDef.tags ? <span className="">{Tool.getLabel(metadata, 'tags', this.props.intl.formatMessage)}: {Tool.getFormatted(metadata, 'tags', this.props.intl.formatMessage, channelDef)}<br/></span> : null}
					</div>

				</div>
			</AppPanel>
		);
	}
}

export default Relay.createContainer(wrapNotFound(injectIntl(ChannelDefDetail), (props) => {
	return props.user.channelDefs.edges.length > 0;
}), {
	initialVariables: {
		channelDefUrlFragment: '',
		channelDefUrlFragments: null,
		relevantScenariosCnt: 0
	},
	prepareVariables (variables) {
		variables.channelDefUrlFragments = getSelectedFragnents();

		return variables;
	},
	fragments: {
		user: () => Relay.QL`
			fragment on User {
				channelDefs: publicChannelDefs(first: 1, urlFragment: $channelDefUrlFragment) {
					edges {
						node {
							id,
							realId,
							urlFragment,
							state,
							addType,
							name,
							keywords,
							aliases,
							typos,
							tags,
							description,
							longDescription,
							connectRequirement,
							hideAddButton,
							extraPayment,
							requiredPayPlan,
							addonRequiredPayPlan,
                            requiresAgent,
							publicWeb,
							icon,
							popularity,
							privacy,
                            showContactUs,
							integratedApps(first: 1000) {
								edges {
									node {
										id,
										realId,
										name,
										description,
										icon,
										type,
										state,
										urlFragment,
										tags,
									}
								}
								pageInfo {
									hasNextPage,
									hasPreviousPage,
									startCursor,
									endCursor
								}
							},
							allScenarios : relevantScenarios(first: 1000, channelDefUrlFragments: $channelDefUrlFragments) {
								edges {
									node {
										id,
										realId,
										state,
										title,
										visibility,
										channelState,
										${ScenarioBox.getFragment('scenario')}
									}
								}
							},
						}
					}
				}
			}
		`,
	},
});
